import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareDeploymentsNextGenRoute: InvariantJiraRoute = {
	name: 'software-deployments',
	path: '/jira/software/projects/:projectKey/deployments',
};
